import {isNil, isString} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import SparklinesChart from 'src/js/common/components/SparklinesChart';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

class SparklinesFormatter extends React.PureComponent {
  render() {
    const {colDef, value} = this.props;
    const formatterParams = new CellRendererParams(
      colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
    );
    const chartType = formatterParams.getChartType();
    let sparklinesData;
    if (!isNil(value)) {
      if (value.value) {
        sparklinesData = JSON.parse(value.value);
      } else if (isString(value)) {
        sparklinesData = JSON.parse(value);
      }
    }

    // sparklinesChartProps are passed to underlying sparklines library component,
    // see prop API reference in PropTypes definition in SparklineChart.js
    const sparklinesChartProps = undefined;
    return sparklinesData ? (
      <SparklinesChart
        chartType={chartType}
        data={sparklinesData}
        sparklinesChartProps={sparklinesChartProps}
        minMaxFromData
      />
    ) : (
      ''
    );
  }
}

SparklinesFormatter.displayName = 'SparklinesFormatter';

SparklinesFormatter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
  ]),
};

SparklinesFormatter.defaultProps = {
  value: undefined,
};

export default SparklinesFormatter;
